import script from "./WordOut.vue?vue&type=script&setup=true&lang=js"
export * from "./WordOut.vue?vue&type=script&setup=true&lang=js"

import "./WordOut.vue?vue&type=style&index=0&id=7ed54cbc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ed54cbc"]])

export default __exports__